import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import { Link } from "react-router-dom";
import {
  deleteProductPerformance,
  getProductPerformance,
} from "../../../apis/ProductPerformanceApi";
import ProductPerformanceFilters from "./ProductPerformanceFilters";

const ProductPerformance = () => {
  const [productPerformance, setProductPerformance] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductPerformance();
    // setLoading(false);
  }, []);
  const fetchProductPerformance = async () => {
    try {
      const res = await getProductPerformance();
      console.log(res, "Tets test test test test tets tets ");
      setProductPerformance(res?.result || []);
      setLoading(false);
    } catch (e) {
      console.log(e, "error");
    }
  };
  const deleteRecord = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Performance ?"
    );
    if (isConfirmed) {
      const deleteRes = await deleteProductPerformance(id);
      console.log(deleteRes, "ttttttt");
      setLoading(true);
      fetchProductPerformance();
    }
  };
  const handleSearch = async (filters) => {
    try {
      setLoading(true);
      const res = await getProductPerformance(null, filters);
      setProductPerformance(res?.result || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "crmProductId",
      dataIndex: "crmProductId",
      width: "30%",
    },
    {
      title: "NAV",
      dataIndex: "nav",
      width: "30%",
    },
    {
      title: "category",
      dataIndex: "category",
      width: "30%",
    },
    {
      title: "Date",
      render: (text, record) => <span>{record?.date?.split("T")[0]}</span>,
      width: "30%",
    },
    {
      title: "quarter",
      dataIndex: "quarter",
      width: "30%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to={`/Add_product_performance/${record.id}`}
              // onClick={() => getAppProducts(record.id)}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteRecord(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "20%",
    },
  ];
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Link
              to="/Add_product_performance"
              className="btn btn-primary mb-3"
            >
              Add Performance
            </Link>
            <div>
              <ProductPerformanceFilters onSearch={handleSearch} />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    Array.isArray(productPerformance) &&
                    productPerformance.length > 0
                      ? productPerformance
                      : []
                  }
                  rowKey="id"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductPerformance;
